import { PaneArea } from '../../../types/shared'
import Curve, { ICurveAttrs } from '../../canvas/curve'
import PaneModel from '../../models/pane'

type Area = PaneArea
type Attrs = ICurveAttrs
type PartialAttrs = Partial<Attrs>

class CurveCreator extends Curve<Attrs> {
  isCreator = true

  constructor(startArea: Area, values: PartialAttrs, model: PaneModel, _: unknown, toolsCallback: () => void) {
    super(values, model)

    const width = this.model.scale.x.width(50)
    const height = this.model.scale.y.height(35)
    this.attrs.x1 = startArea.x
    this.attrs.x2 = startArea.x + width
    this.attrs.x3 = startArea.x + width * 2
    this.attrs.y1 = startArea.y
    this.attrs.y2 = startArea.y + height
    this.attrs.y3 = startArea.y

    // reason for setTimeout is that you need to run this.replaceMyself() in another
    // CPU tick || delay +- 10ms || as another task in BrowserQueue,
    // if it isn't there curve is not defined yet and you get error
    // Uncaught TypeError: Cannot read property 'replace' of undefined
    // deeper explanation here https://stackoverflow.com/a/779785
    setTimeout(() => {
      this.replaceMyself(Curve.fromObject<Curve>(this.attrs, this.model))
      toolsCallback()
    })

    window.gtag?.('event', 'create', { event_category: 'tools', event_label: this.name })
  }
}

export default CurveCreator
